module.exports = __webpack_public_path__ + "static/media/19ESCAP1.800f0555.jpg";